module.exports = __webpack_public_path__ + "static/media/spanish-adjectives-table-1.d775265d.JPG";